// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R5NIdu {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--background-alt);
  padding-bottom: var(--spacing-3);
}

.X43W88 {
  display: flex;
  flex: 1;
  gap: var(--spacing-3);
  min-height: 0;
  height: 100%;
  padding-top: var(--spacing-3);
}

.FZTcqz {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
}

._GigjQ {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: var(--spacing-3);
  min-width: 0;
}

.qrQgzV {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.cEoDVJ {
  width: 355px;
  height: 100%;
}

.S0UWK4 {
  margin-top: var(--spacing-3);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DigitalAccountNavBarAndNavCardsLayout/DigitalAccountNavBarAndNavCardsLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".layoutRoot {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: var(--background-alt);\n  padding-bottom: var(--spacing-3);\n}\n\n.layoutContent {\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-3);\n  min-height: 0;\n  height: 100%;\n  padding-top: var(--spacing-3);\n}\n\n.layoutLoading {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.accountLayoutContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: var(--spacing-3);\n  min-width: 0;\n}\n\n.mainContent {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n\n.sideContent {\n  width: 355px;\n  height: 100%;\n}\n\n.breadcrumb {\n  margin-top: var(--spacing-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutRoot": `R5NIdu`,
	"layoutContent": `X43W88`,
	"layoutLoading": `FZTcqz`,
	"accountLayoutContent": `_GigjQ`,
	"mainContent": `qrQgzV`,
	"sideContent": `cEoDVJ`,
	"breadcrumb": `S0UWK4`
};
module.exports = ___CSS_LOADER_EXPORT___;
